export default __webpack_public_path__ + "static/Epsagon-13516a2fa6e795510a7936afb5666dd0.png";